

<!-- Home.vue -->
<template>
  <div class="home-container">
    <!-- Header -->
    <header :class="['main-header', { 'fixed-top': isFixedTop }]">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="header-content"
      >
        <el-col :span="4">
          <!-- Logo -->
          <router-link to="/">
            <img :src="logo_url" alt="Logo" class="logo" />
          </router-link>
        </el-col>
        <el-col :span="4" class="menu-toggle-wrapper">
          <!-- Navigation Menu Toggle Button for Mobile -->
          <i
            class="el-icon-menu toggle-button"
            @click="toggleMenu"
            v-if="isMobile"
          ></i>
        </el-col>
        <el-col :span="16" v-if="!isMobile" class="menu-wrapper">
          <!-- Navigation Menu -->
          <el-menu
            mode="horizontal"
            router
            :default-active="$route.path"
            class="nav-menu"
          >
            <el-menu-item index="/">Home</el-menu-item>
            <el-menu-item index="/privacy">Privacy</el-menu-item>
            <!-- <el-menu-item index="/download">Download</el-menu-item> -->
            <el-menu-item index="/about">About us</el-menu-item>
            <el-menu-item index="/contact">Contact</el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </header>

    <!-- Mobile Menu Overlay -->
    <transition name="slide-fade">
      <div v-if="isMobile && !isMenuCollapsed" class="mobile-menu-overlay">
        <el-menu
          mode="vertical"
          router
          :default-active="$route.path"
          class="mobile-menu"
        >
          <el-menu-item index="/">Home</el-menu-item>
          <!-- <el-menu-item index="/news">News</el-menu-item>
          <el-menu-item index="/download">Download</el-menu-item> -->
          <el-menu-item index="/about">About Us</el-menu-item>
          <el-menu-item index="/contact">Contact</el-menu-item>
          <el-menu-item index="/privacy">privacy</el-menu-item>
        </el-menu>
      </div>
    </transition>

    <!-- Main Content -->
    <main class="main-content">
      <router-view></router-view>
      <!-- 子路由内容在这里渲染 -->
    </main>

    <footer class="footer">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="footer-top"
      >
        <!-- 左边Logo -->
        <el-col :span="6" class="footer-logo">
          <img :src="logoSrc" :alt="logoAlt" />
        </el-col>

        <!-- 中间菜单链接 -->
        <el-col :span="12" class="footer-menu">
          <ul>
            <li v-for="(link, index) in menuLinks" :key="index">
              <a :href="link.href">{{ link.text }}</a>
            </li>
          </ul>
        </el-col>

        <!-- 右边支付Logo -->
        <!-- <el-col :span="6" class="footer-payment">
        <img :src="paymentLogoSrc" :alt="paymentLogoAlt" />
      </el-col> -->

        <!-- 右边社交图标 -->
        <el-col :span="6" class="footer-social-icons">
          <ul>
            <li v-for="(icon, index) in socialIconsImage" :key="index">
              <a :href="icon.href" target="_blank" rel="noopener noreferrer">
                <img :src="icon.src" :alt="icon.alt" />
              </a>
            </li>
          </ul>
        </el-col>
      </el-row>

      <!-- 新增的社交分享条 -->
      <!-- <section
        class="MC_globalFooterA_socialStripe"
        data-aem-item="mc-globalGooterA-socialshare"
        data-bi-id="r1a2"
        data-bi-cn="mc-globalGooterA-socialshare 1"
        data-module-id="container"
      >
        <h2 class="MC_Heading_5"></h2>
        <nav aria-label="" data-bi-id="m1r1a2" data-bi-cn="m1r1a2">
          <ul class="MC_globalFooterA_socialStripe-list">
            <li v-for="(icon, index) in socialIcons" :key="index">
              <a
                :href="icon.href"
                :aria-label="icon.ariaLabel"
                :title="icon.title"
                target="_blank"
                class="MC_globalFooterA_socialStripe-icon"
                role="link"
                :style="`--fill-color: ${icon.color}; --background-color: ${icon.backgroundColor};`"
                :data-bi-id="icon.dataBiId"
                :data-bi-ct="icon.dataBiCt"
                :data-bi-cn="icon.dataBiCn"
                :data-bi-ecn="icon.dataBiEcn"
                :data-bi-socchn="icon.dataBiSocchn"
                :data-bi-bhvr="icon.dataBiBhvr"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  role="presentation"
                >
                  <rect
                    width="40"
                    height="40"
                    rx="20"
                    :fill="icon.backgroundColor"
                  ></rect>
                  <path
                    :d="icon.path"
                    :fill="icon.color"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </section> -->

      <!-- 最下方版权信息 -->
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} {{ copyrightInfo }}</p>
      </div>
    </footer>

    <!-- Footer -->
    <!-- <footer class="page-footer">
      <p>&copy; {{ new Date().getFullYear() }} Exmotocross. All Rights Reserved.</p>
    </footer> -->
  </div>
</template>



<script>
export default {
  name: "Home",
  data() {
    return {
      logo_url: require("@/assets/img/20250324183410.png"), // 确保路径正确
      isMenuCollapsed: true, // 默认情况下菜单是折叠的
      isMobile: false, // 默认不是移动设备
      isFixedTop: false, // 控制是否固定在顶部
      scrollThreshold: 100, // 滚动阈值，单位为像素
      logoSrc: require("@/assets/img/20250324183410.png"), // 替换为实际Logo路径
      logoAlt: "Company Logo",
      menuLinks: [
        { href: "#", text: "Home" },
        { href: "/about", text: "About Us" },
        { href: "/privacy", text: "Privacy" },
        { href: "/contact", text: "Contact" },
        // 添加更多链接
      ],
      socialIconsImage: [
        {
          href: "#",
          src: require("@/assets/img/pegi.png"),
          alt: "",
        },
      ],
      socialIcons: [
        {
          href: "https://www.facebook.com",
          ariaLabel: "Follow us on Facebook",
          title: "Facebook",
          color: "#ffffff", // 图标颜色
          backgroundColor: "#3b5998", // 背景颜色
          path: "M27.8861 25.8641L28.7671 20.1165H23.2557V16.3883C23.2557 14.8155 24.0242 13.2816 26.4927 13.2816H29V8.38835C29 8.38835 26.7256 8 24.5521 8C20.011 8 17.0457 10.7534 17.0457 15.7359V20.1165H12V25.8641H17.0457V39.7592C18.0587 39.9184 19.095 40 20.1507 40C21.2064 40 22.2427 39.9184 23.2557 39.7592V25.8641H27.8861Z", // 正确的Facebook图标路径
          dataBiId: "fbIcon",
          dataBiCt: "social",
          dataBiCn: "follow_facebook",
          dataBiEcn: "external",
          dataBiSocchn: "facebook",
          dataBiBhvr: "click",
        },
        {
          href: "https://www.youtube.com",
          ariaLabel: "Follow us on YouTube",
          title: "YouTube",
          color: "#ffffff", // 图标颜色
          backgroundColor: "#ff0000", // 背景颜色
          path: "M29.3904 12.4894C30.4184 12.7529 31.229 13.5247 31.5058 14.5035C32.0198 16.2918 32 20.0188 32 20.0188C32 20.0188 32 23.7271 31.5058 25.5153C31.229 26.4941 30.4184 27.2659 29.3904 27.5294C27.5123 28 20 28 20 28C20 28 12.5074 28 10.6096 27.5106C9.58155 27.2471 8.771 26.4753 8.49423 25.4965C8 23.7271 8 20 8 20C8 20 8 16.2918 8.49423 14.5035C8.771 13.5247 9.60132 12.7341 10.6096 12.4706C12.4876 12 20 12 20 12C20 12 27.5123 12 29.3904 12.4894ZM23.855 20.0001L17.6079 23.426V16.5742L23.855 20.0001Z", // 正确的YouTube图标路径
          dataBiId: "ytIcon",
          dataBiCt: "social",
          dataBiCn: "follow_youtube",
          dataBiEcn: "external",
          dataBiSocchn: "youtube",
          dataBiBhvr: "click",
        },
        {
          href: "https://x.com/",
          ariaLabel: "Follow us on X",
          title: "X",
          color: "#ffffff", // 图标颜色
          backgroundColor: "#262423", // 背景颜色
          path: "M21.9,18.5l7.3-8.5h-1.7l-6.3,7.4-5.2-7.4h-5.8l7.6,11.1-7.6,8.9h1.7l6.7-7.8,5.4,7.8h5.8l-7.9-11.5ZM19.5,21.2l-.8-1.1-6.2-8.8h2.7l5,7.1.8,1.1,6.5,9.2h-2.7l-5.3-7.5Z", // 正确的YouTube图标路径
          dataBiId: "ytIcon",
          dataBiCt: "social",
          dataBiCn: "follow_X",
          dataBiEcn: "external",
          dataBiSocchn: "X",
          dataBiBhvr: "click",
        },

        {
          href: "https://www.instagram.com/",
          ariaLabel: "Follow us on instagram",
          title: "instagram",
          color: "#ffffff", // 图标颜色
          backgroundColor: "#f1437a", // 背景颜色
          path: "M19.9952 10.1623C23.1998 10.1623 23.5761 10.1766 24.8427 10.2338C26.0141 10.2862 26.6476 10.4815 27.0713 10.6481C27.6333 10.8672 28.0333 11.1244 28.4524 11.5436C28.8712 11.9627 29.1333 12.3628 29.3477 12.9248C29.5093 13.3487 29.7093 13.9821 29.7617 15.1538C29.8188 16.4207 29.8332 16.797 29.8332 20.0024C29.8332 23.2078 29.8188 23.584 29.7617 24.8509C29.7093 26.0226 29.5143 26.6561 29.3477 27.08C29.1286 27.642 28.8712 28.042 28.4524 28.4612C28.0333 28.8804 27.6333 29.1423 27.0713 29.3566C26.6476 29.5185 26.0141 29.7186 24.8427 29.771C23.5761 29.8281 23.1998 29.8424 19.9952 29.8424C16.7905 29.8424 16.4142 29.8281 15.1476 29.771C13.9762 29.7186 13.3428 29.5233 12.919 29.3566C12.7978 29.3094 12.6841 29.2603 12.5761 29.2083C12.5117 29.1771 12.4493 29.145 12.3884 29.1115C12.0791 28.9411 11.8126 28.7359 11.5382 28.4612C11.1192 28.042 10.8571 27.642 10.643 27.08C10.481 26.6561 10.281 26.0226 10.2286 24.8509C10.2028 24.2784 10.1858 23.8878 10.1747 23.3358C10.1615 22.6663 10.1571 21.7593 10.1571 20.0024C10.1571 16.797 10.1715 16.4207 10.2286 15.1538C10.281 13.9821 10.4761 13.3487 10.643 12.9248C10.862 12.3628 11.1192 11.9627 11.5382 11.5436C11.957 11.1244 12.357 10.8625 12.919 10.6481C13.3428 10.4862 13.9762 10.2862 15.1476 10.2338C16.4142 10.1719 16.7952 10.1623 19.9952 10.1623ZM19.9952 8C16.7381 8 16.3284 8.01428 15.0475 8.07147C13.7715 8.12859 12.9 8.33341 12.138 8.62873C11.3476 8.93351 10.681 9.3479 10.0142 10.0147C9.3477 10.6815 8.938 11.353 8.62846 12.1389C8.33326 12.901 8.12856 13.7726 8.07146 15.0538C8.01435 16.3302 8 16.7398 8 19.9976C8 21.3813 8.00264 22.2511 8.00996 22.8922C8.01991 23.7606 8.03866 24.2092 8.07146 24.9462C8.12856 26.2226 8.33326 27.0943 8.62846 27.8611C8.93332 28.6517 9.3477 29.3185 10.0142 29.9853C10.681 30.6521 11.3523 31.0617 12.138 31.3713C12.9 31.6666 13.7715 31.8714 15.0524 31.9285C16.3334 31.9857 16.7381 32 19.9999 32C23.2619 32 23.6666 31.9857 24.9476 31.9285C26.2238 31.8714 27.095 31.6666 27.8617 31.3713C28.6521 31.0665 29.319 30.6521 29.9855 29.9853C30.6523 29.3185 31.0617 28.647 31.3712 27.8611C31.6664 27.099 31.8714 26.2275 31.9285 24.9462C31.9857 23.665 32 23.2602 32 19.9976C32 16.735 31.9857 16.3302 31.9285 15.049C31.8714 13.7726 31.6664 12.901 31.3712 12.1341C31.0667 11.3435 30.6523 10.6767 29.9855 10.01C29.319 9.34314 28.6474 8.93351 27.8617 8.6239C27.1 8.32865 26.2285 8.12383 24.9476 8.06671C23.662 8.01428 23.2523 8 19.9952 8ZM19.9952 13.8392C16.5952 13.8392 13.8333 16.5969 13.8333 20.0024C13.8333 23.4078 16.5905 26.1655 19.9952 26.1655C23.3999 26.1655 26.157 23.4078 26.157 20.0024C26.157 16.5969 23.3999 13.8392 19.9952 13.8392ZM19.9952 23.9984C17.7856 23.9984 15.9951 22.2076 15.9951 19.9976C15.9951 17.7877 17.7856 15.9968 19.9952 15.9968C22.2047 15.9968 23.9952 17.7877 23.9952 19.9976C23.9952 22.2076 22.2047 23.9984 19.9952 23.9984ZM27.838 13.5916C27.838 14.386 27.1943 15.0299 26.4001 15.0299C25.6059 15.0299 24.9619 14.386 24.9619 13.5916C24.9619 12.7971 25.6059 12.1532 26.4001 12.1532C27.1943 12.1532 27.838 12.7971 27.838 13.5916Z", // 正确的YouTube图标路径
          dataBiId: "ytIcon",
          dataBiCt: "social",
          dataBiCn: "follow_instagram",
          dataBiEcn: "external",
          dataBiSocchn: "instagram",
          dataBiBhvr: "click",
        },
        // 添加其他社交图标
      ],
      paymentLogoSrc: require("@/assets/img/esrb_2021 .svg"), // 替换为实际支付Logo路径
      paymentLogoAlt: "Payment Methods",
      currentYear: new Date().getFullYear(),
      copyrightInfo: "Exmotocross.com. All Rights Reserved.",
    };
  },
  created() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleScroll() {
      this.isFixedTop = window.scrollY > this.scrollThreshold;
    },
  },
};
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  position: relative;
}

.white-header {
  background-color: #fff;
  padding: 10px 20px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  box-shadow: 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%),
    0 2px 4px -1px rgb(0 0 0 / 20%);
  z-index: 3;
}

.mobile-header {
  position: relative;
}

.header-content {
  justify-content: space-between;
}

.footer {
  background-color: #878b8f;
  padding: 40px 0;
  color: #fff;
}

.footer-top {
  margin-bottom: 20px;
}

.footer-logo img,
.footer-payment img {
  max-width: 100%;
  height: auto;
}

.footer-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
}

.footer-menu ul li {
  margin: 0 15px;
}

.footer-menu ul li a {
  color: #fff;
  text-decoration: none;
  /* font-weight: bold; */
  font-weight: 300;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  font-weight: 300;
  border-top: 1px solid #ddd;
}

.footer-bottom p {
  margin: 0;
  font-size: 0.9em;
}

.footer-social-icons ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
}

.footer-social-icons ul li {
  margin: 0 10px;
}

.footer-social-icons ul li img {
  /* width: 242px; */
  /* height: 40px; */
}

.MC_globalFooterA_socialStripe {
  margin-bottom: 20px;
  text-align: center;
}

.MC_Heading_5 {
  font-size: 1.2em;
  margin-bottom: 10px;
}

.MC_globalFooterA_socialStripe-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
}

.MC_globalFooterA_socialStripe-list li {
  margin: 0 10px;
}

.MC_globalFooterA_socialStripe-icon {
  display: inline-block;
  transition: transform 0.3s ease;
}

.MC_globalFooterA_socialStripe-icon:hover {
  transform: scale(1.1);
}

.MC_globalFooterA_socialStripe-icon svg rect {
  transition: fill 0.3s ease;
}

.MC_globalFooterA_socialStripe-icon svg path {
  transition: fill 0.3s ease;
}

.main-header {
  background-color: #fff;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保头部在所有内容之上 */
  width: 100%;
}

.header-content {
  justify-content: space-between;
}

@media (max-width: 768px) {
  .MC_globalFooterA_socialStripe-list {
    flex-wrap: wrap;
  }

  .MC_globalFooterA_socialStripe-list li {
    margin: 5px;
  }
  .footer-menu ul {
    flex-direction: column;
    align-items: center;
  }

  .footer-menu ul li {
    margin: 10px 0;
  }

  .footer-top {
    flex-wrap: wrap;
  }

  .footer-logo,
  .footer-payment {
    text-align: center;
    width: 100%;
    margin-bottom: 15px;
  }
}

.logo {
  width: 250px;
  margin-top: 10px; /* 如果需要可以调整 */
}

.toggle-button {
  font-size: 24px;
  cursor: pointer;
  display: none; /* 默认不显示 */
}

.nav-menu {
  display: flex;
  /* justify-content: flex-end; */
  width: 100%;
}

.nav-menu .el-menu-item {
  font-size: 16px;
  margin-left: 20px;
  color: #000; /* 文字颜色改为黑色 */
  text-decoration: none; /* 去除下划线 */
}
/* 鼠标悬停时的效果 */
.nav-menu .el-menu-item:hover {
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow, 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05));
  background-color: #f1f1f1; /* 设置背景颜色 */
}
.mobile-menu {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  border-top: 1px solid #ebeef5;
  z-index: 1001;
  flex-direction: column;
  background-color: #fff;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.main-content {
  padding-top: 80px; /* 为主要内容添加与头部等高的上边距 */
}

.page-footer {
  background-color: #f9f9f9;
  text-align: center;
  padding: 20px 0;
  margin-top: 20px;
}

@media only screen and (max-width: 768px) {
  /* .nav-menu .el-menu-item {
    font-size: 14px;
    margin-left: 10px;
  } */

  .nav-menu {
    display: none; /* 移动端隐藏水平菜单 */
  }

  .toggle-button {
    display: block;
  }
  .main-content {
    padding-top: 60px; /* 移动设备上的头部高度可能不同 */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/pages/Home.vue